import React from 'react'
import FormSelect from 'react-bootstrap/FormSelect'
import { BasicOption, SelectProps } from './types'

const Select = <T extends BasicOption>(props: SelectProps<T>) => {
    const { isMultiple = false, id, name, data, value, onChange } = props

    return (
        <FormSelect
            id={id}
            name={name}
            multiple={isMultiple}
            value={value}
            onChange={onChange}>
            <option value="" hidden></option>
            {data.map((el, i) => (
                <option key={i} value={el.value}>
                    {el.name}
                </option>
            ))}
        </FormSelect>
    )
}

export default Select
